import React from "react";
import CustomDialog from "../../../components/dialog";
import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import PersonalDetailsForm from "./personal";
import EIADetailsForm from "./einsurance";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import {
  Box,
  Checkbox,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { isAdditionalDetailsProceedButtonDisabled } from "../../../helpers/validation";
import { BUTTON_PROCEED } from "../../../constants";

function ProposalDetailsForm({
  classes: { containerButton, formGroup, main },
  errorMessage,
  errors,
  form,
  handleAccordionChange,
  handleBack,
  handleChange,
  handleChangeChipSelect,
  handleCheckboxChange,
  handleClose,
  handleOnClose,
  isFormSubmitted,
  modal,
  occupations,
  onSubmit,
  options,
  orderDetails,
  panDetails = null,
  panErrorMessage = "",
  isPanVerifiedError = false,
  section,
  selectedOccupationOption,
  setSelectedOccupationOption,
  validateInputLength,
  verifyPancardDetails,
}) {
  return (
    <Box className={main} p={0}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1}>
          <SectionTitle
            title={"Application Form Details"}
            onClickHandler={handleBack}
          />
        </Box>
        <form noValidate autoComplete="off" onSubmit={onSubmit}>
          <Box direction="column">
            <PersonalDetailsForm
              errorMessage={errorMessage}
              form={form}
              handleAccordionChange={handleAccordionChange}
              handleChange={handleChange}
              handleChangeChipSelect={handleChangeChipSelect}
              handleCheckboxChange={handleCheckboxChange}
              isFormSubmitted={isFormSubmitted}
              occupations={occupations}
              options={options}
              orderDetails={orderDetails}
              panErrorMessage={panErrorMessage}
              isPanVerifiedError={isPanVerifiedError}
              section={section}
              selectedOccupationOption={selectedOccupationOption}
              setSelectedOccupationOption={setSelectedOccupationOption}
              validateInputLength={validateInputLength}
              verifyPancardDetails={verifyPancardDetails}
            />

            <EIADetailsForm
              errorMessage={errorMessage}
              form={form}
              handleAccordionChange={handleAccordionChange}
              handleChange={handleChange}
              handleChangeChipSelect={handleChangeChipSelect}
              handleCheckboxChange={handleCheckboxChange}
              options={options}
              section={section}
              validateInputLength={validateInputLength}
            />
          </Box>

          <ErrorMessage errors={errors} modal={modal} />

          <Box
            className={containerButton}
            justifyContent="center"
            alignContent="center"
            alignItems="flex-start"
          >
            {/* {form.income_tax_proof === "PAN" && (
              <Box mb={1} sx={{ textAlign: "left" }}>
                <FormControlLabel
                  control={
                    <Box style={{ alignSelf: "start" }}>
                      <Checkbox
                        checked={form.declaration}
                        onChange={handleCheckboxChange}
                        name={"declaration"}
                        color="primary"
                      />
                    </Box>
                  }
                  label={
                    <Box mt={1}>
                      <Typography variant="caption">
                        I hereby confirm that the name fetched from PAN card and
                        from Aadhaar card are of the same person.
                      </Typography>
                    </Box>
                  }
                />
              </Box>
            )} */}

            <CallToAction
              buttonType={"submit"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={isAdditionalDetailsProceedButtonDisabled(
                isFormSubmitted,
                form,
                errorMessage,
                selectedOccupationOption
              )}
              isFormSubmitted={isFormSubmitted}
              text={BUTTON_PROCEED}
              handleClick={() => {}}
            />
          </Box>

          {modal.occupation && (
            <CustomDialog
              handleOnClose={handleOnClose}
              modal={modal}
              modalKey={"occupation"}
              title={"High Risk Occupation"}
              subtitle={"We're Sorry, But We Can't Proceed"}
              text={
                "Based on the information provided, your occupation falls under a high-risk category. Unfortunately, this means we’re unable to move forward at this time."
              }
            />
          )}

          {modal.pancard && (
            <CustomDialog
              buttonText={"Close"}
              handleOnClose={handleOnClose}
              modal={modal}
              modalKey={"pancard"}
              title={"Pancard Verification"}
              subtitle={""}
              text={
                "There was an error in PAN card verification. Please try again."
              }
            />
          )}

          {modal.snackbar && (
            <NotificationMessage
              open={modal.snackbar}
              message={"Appropriate message need to place here."}
              onClose={() => handleClose("snackbar", false)}
            />
          )}

          {modal.panMismatch && (
            <Dialog
              aria-labelledby="simple-dialog-title"
              fullScreen={true}
              fullWidth={true}
              onClose={() => handleClose("panMismatch", false)}
              open={modal.panMismatch}
              maxWidth={"lg"}
            >
              <DialogTitle id="simple-dialog-title">
                <Box display="flex" justifyContent="center">
                  <SectionTitle
                    backButton={false}
                    // onClickHandler={handleBack}
                    title={"Details Mismatch"}
                  />
                </Box>
              </DialogTitle>

              <Box>
                <Box m={1} pt={0} pb={0}>
                  <Box className={formGroup}>
                    <Typography variant="body2">
                      <strong>Customer PAN:</strong> {panDetails?.pan}
                    </Typography>
                  </Box>
                  <Box>
                    <Box className={formGroup}>
                      <Typography variant="body1">Customer Name</Typography>
                    </Box>
                    <Card
                      sx={{
                        border: "1px solid #e0e0e0",
                        background: "#f8f8f8bd",
                        borderRadius: 2,
                        p: 1,
                        pt: 0,
                        m: 0,
                        pb: 0,
                        boxShadow:
                          "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                        transition: "box-shadow .2s",
                      }}
                    >
                      <CardContent sx={{ p: 1 }}>
                        <Box className={formGroup}>
                          <Typography variant="body2">
                            <strong>Aadhaar:</strong>{" "}
                            {panDetails?.customer_name ?? "NA"}
                          </Typography>
                        </Box>
                        <Box className={formGroup}>
                          <Typography variant="body2">
                            <strong>PAN:</strong>{" "}
                            {panDetails?.name_in_pan ?? "NA"}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                  <Box mt={2}>
                    <Box className={formGroup}>
                      <Typography variant="body1">Customer DOB</Typography>
                    </Box>
                    <Card
                      sx={{
                        border: "1px solid #e0e0e0",
                        background: "#f8f8f8bd",
                        borderRadius: 2,
                        p: 1,
                        pt: 0,
                        m: 0,
                        pb: 0,
                        boxShadow:
                          "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                        transition: "box-shadow .2s",
                      }}
                    >
                      <CardContent sx={{ p: 1 }}>
                        <Box className={formGroup}>
                          <Typography variant="body2">
                            <strong>Aadhaar:</strong>{" "}
                            {panDetails?.customer_dob ?? "NA"}
                          </Typography>
                        </Box>
                        <Box className={formGroup}>
                          <Typography variant="body2">
                            <strong>PAN:</strong>{" "}
                            {panDetails?.dob_in_pan ?? "NA"}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                  <Box mt={2}>
                    <Box className={formGroup}>
                      <Typography variant="body1">Remark</Typography>
                    </Box>
                    <Card
                      sx={{
                        border: "1px solid #e0e0e0",
                        background: "#f8f8f8bd",
                        borderRadius: 2,
                        p: 1,
                        pt: 0,
                        m: 0,
                        pb: 0,
                        boxShadow:
                          "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                        transition: "box-shadow .2s",
                      }}
                    >
                      <CardContent sx={{ p: 1 }}>
                        <Typography variant="body2">
                          Since <strong>partial match found</strong>, this may
                          need to an <strong>RTS</strong>.
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                </Box>
                <Box className={containerButton}>
                  <Box mt={1}>
                    <CallToAction
                      buttonType={"click"}
                      errorMessage={errorMessage}
                      form={form}
                      isDisabled={false}
                      isFormSubmitted={isFormSubmitted}
                      text={"CLOSE"}
                      handleClick={() => handleClose("panMismatch", false)}
                    />
                  </Box>
                </Box>
              </Box>
            </Dialog>
          )}
        </form>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProposalDetailsForm);
